import React from 'react'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const ChangeItem = ({ changeField }) => {
  return (
    <div className='changesBlock__item'>
        <p>
			{
				changeField.name ? changeField.name : changeField.fieldName
			}
		</p>
        <div className='changesBlock__item-values'>
            <p className='changesBlock__item-values-old'>{changeField.valueOld}</p>
            <p>
                <ArrowRightAltIcon />
            </p>
            <p className='changesBlock__item-values-new'>{changeField.valueNew}</p>
        </div>
    </div>
  )
}

export default ChangeItem